import { Card, Tag } from 'antd';
import { OrderDetailGrid } from 'components/ArticleOrder';
import ActivityHistory from 'components/ActivityHistory';
import ArticleOrderMediaWrapper from 'components/ArticleOrderMedia/ArticleOrderMediaWrapper';
import { useMediaOfferPermission } from 'hooks';

/**
 * @description "Yayına Hazır" sekmesi: maddenin ve ilişkili belgelerin son versiyonlarını özetler.
 *
 * Sekme yalnız `step === PUBLISH` iken açılır (bkz. `ArticleProcess`). Medya tablosu herkes için
 * salt-görüntülemedir; tek istisna admin/süper admin (`canManageAllRows`).
 *
 * @param {Object} props
 * @param {Object} props.offer Madde teklifi (`ArticleOffer`) — başlık, özet alanları ve medya tablosunun kaynağı.
 */
const Publisment = ({ offer }) => {
  const mediaOfferPermission = useMediaOfferPermission(offer);

  return (
    <>
      <Tag
        className="gx-p-3"
        color="green"
      >
        {offer && offer.title} maddesinin aşağıda ana başlıklarıyla listelenen süreçleri tamamlanmış, basılı ve elektronik olarak yayına hazır hale gelmiştir.
        Madde ve madde ile ilişkili belgelerin son versiyonları aşağıdadır.
      </Tag>
      <Card>
        <OrderDetailGrid offer={offer} />
      </Card>
      <Card>
        <ActivityHistory
          id={offer.id}
          requestType="post_offer"
        />
        <ArticleOrderMediaWrapper
          isContentSend
          offerID={offer.id}
          permission={mediaOfferPermission}
          isCommiteeControlColumnsVisible={!mediaOfferPermission.isReadOnly}
        />
      </Card>
    </>
  );
};

export default Publisment;
